import {OrderListColumns} from "../../components/list/models/OrderListColumns";

export default [
    "account",
    "side",
    "filled",
    "code",
    "exchange",
    "expiry",
    "strike",
    "limit",
    "average-price",
    "created",
    "updated",
] as OrderListColumns;
